export const ROLE_LABEL = { superadmin: "Super Admin", admin: "Admin", cs: "Customer Service" };

export const isAdminRole = (role) => role === "admin" || role === "superadmin";
